/**
 * Inscriptions with no collection (most unlisted items) have no slug.
 * Collection actions must still open, so fall back to the virtual
 * 'uncategorized' collection instead of passing undefined along (#590).
 */
export function resolveCollectionSlug(slug: string | null | undefined): string {
	return typeof slug === 'string' && slug.length > 0 ? slug : 'uncategorized'
}
